import { extendTheme } from '@chakra-ui/react';

/** Default Croham City shell (unchanged). */
export const crohamBaseTheme = extendTheme({});
